import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';

import {Hub} from '../types/hub';
import {HubService} from '../services/hub.service';
import {AppComponent} from '../app.component';

@Component({
  selector: 'hubs',
  template: `<hubs-sub-menu></hubs-sub-menu>
<div>Showing {{hubCount}} hubs</div>
<ul class="hubs">
  <li class="h3">
    <one-hub [header]="true" (sortColumn)="onSortColumn($event)"></one-hub>
  </li>
  <li *ngFor="let hub of hubs"
      [class.selected]="hub === currentHub"
      (click)="gotoDetail(hub)">
    <one-hub [inHub]="hub"></one-hub>
  </li>
</ul>
`,
  styles: [
    `.selected { background-color: #CFD8DC !important; color: white; }`,
    `.hubs { margin: 0 0 2em 0; list-style-type: none; padding: 0; min-width: 32em; width: 100%; }`,
    `.hubs li { display: block; background-color: #EEE; margin: 0.2em 0; vertical-align: middle; }`,
    `.hubs li:hover { color: #304D6B; background-color: #DDD; }`,
  ],
  providers: [HubService],
})


export class NewHubsComponent implements OnInit {
  hubCount = 0;
  hubs: Hub[];
  allHubs: Hub[];
  currentHub: Hub;
  errorMessage: any;
  matchingParams: Params;
  sortColumn: string;
  sortAscending: boolean;
  sortNumeric: boolean;

  constructor(
    private hubService: HubService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    AppComponent.SetTitle('New Hubs');
    this.getNewHubs();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.matchingParams = params;
      this.matchHubs();
    });
  }

  getNewHubs(): void {
    this.hubService.getNewHubs()  .subscribe(
      hubs => this.updatedHubs(hubs),
      error => this.errorMessage = <any>error,
    );
  }

  private updatedHubs(newHubs: Hub[]): void {
    this.allHubs = newHubs;
    try {
      this.matchHubs();
    } catch (e) {
      this.hubs = this.allHubs;
    }
    this.hubCount = this.hubs.length;
  }

  private matchHubs(): void {
    // No matching yet
    /*
    if (this.allHubs) {
      for (const key of Object.keys(this.allHubs)) {
        try {
        } catch (e) {
          console.error(e);
        }
      }
    }
    */
    this.hubs = this.allHubs;
    if (!!this.sortColumn) {
      this.sortHubs();
    }
  }

  onSortColumn(e: string) {
    let columnSort = e.split(':');
    this.sortBy(columnSort[0], columnSort[1] === 'true');
  }

  sortBy(column: string, numeric: boolean): void {
    if (this.sortColumn && this.sortColumn === column) {
      this.sortAscending = !this.sortAscending;
    } else {
      this.sortColumn = column;
      this.sortNumeric = numeric;
      this.sortAscending = true;
    }
    this.sortHubs();
  }

  private sortHubs(): void {
    let sortColumn = this.sortColumn;
    let sortNumeric = this.sortNumeric;
    let sortAscending = this.sortAscending;
    this.hubs.sort(function(a, b) {
      let result = 0;
      try {
        let f1 = a[sortColumn];
        let f2 = b[sortColumn];
        if (sortNumeric) {
          result = f1 - f2;
        } else {
          result = (f1 < f2 ? -1 : (f1 > f2 ? 1 : 0));
        }
        if (!sortAscending) {
          result *= -1;
        }
      } catch (e) {
        console.log(e.message);
        console.log(`sortColumn: ${sortColumn}`);
        console.log(`a: ${JSON.stringify(a, null, 2)}`);
      }
      return result;
    });
  }

  gotoDetail(hub: Hub): void {
    this.router.navigate(['/hub', hub.hubid]);
  }

}

